/*
 * Copyright (c) 2018 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained here in is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import { Button, Grid } from "@material-ui/core";
import * as React from "react";

import { theme } from "../../theme/theme";
import { Form } from "../../types/Form";
import { UiFormBuilder } from "../../utils/UiFormBuilder";
import { UpdateRequestBuilder } from "../../utils/UpdateRequestBuilder";
import InputEmail from "../InputEmail/InputEmail";

interface FormLostPasswordType {
    email: string;
    password: string;
    passwordConfirmation: string;
}

interface FormLostPasswordProps {
    onSubmit?: (email, password) => void;
}

type FormLostPasswordState = {
    form: Form<FormLostPasswordType>;
};

export class FormLostPassword extends React.Component<FormLostPasswordProps, FormLostPasswordState> {

    protected formBuilder: any = null;
    protected form: any = null;

    componentWillMount() {
        this.formBuilder = new UiFormBuilder<FormLostPasswordType>()
            .addField("email", {
                props: {
                    label: "Email",
                    required: true
                }
            })
            .addField("password", {
                props: {
                    label: "Mot de passe",
                    required: true
                }
            })
            .addField("passwordConfirmation", {
                props: {
                    label: "Confirmation de mot de passe",
                    required: true
                }
            })
            .onChange(this.onChange.bind(this))
            ;

        this.setState({
            form: {
                fields: {},
                errors: [],
                values: {
                    email: "",
                    password: "",
                    passwordConfirmation: ""
                }
            }
        });
    }

    public onChange(fieldName: string, value: any) {
        const builder = new UpdateRequestBuilder();
        builder.set(`values.${fieldName}`, value);
        let form = builder.exec(this.state.form);
        this.setState({ form: form });
    }

    public onSubmit(e) {
        e.preventDefault();
        if (this.form.reportValidity() && this.props.onSubmit) {
            this.props.onSubmit(this.state.form.values.email, this.state.form.values.password);
        }
    }

    public render() {
        if (!this.state) {
            return null;
        }
        const uiForm = this.formBuilder.build(this.state.form);
        return (
            <form ref={(ref) => this.form = ref} onSubmit={this.onSubmit.bind(this)}>
                <Grid container={true} spacing={16}>
                    <Grid item={true} sm={12}>
                        <InputEmail {...uiForm.fields.email} />
                    </Grid>
                    <Grid item={true} sm={12} style={{ marginTop: `${theme.spacing.unit * 2}px`, textAlign: "right" }}>
                        <Button type="submit" variant="contained" color="primary" size="large">Changer le mot de passe</Button>
                    </Grid>
                </Grid>
            </form>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/FormLostPassword/FormLostPassword.tsx